import { ApiBaseService, ApiV2Service } from './api.base.service';
import {NotificationBanner} from '@/types';
export class NotificationBannerService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async getCurrentNotificationBanner(): Promise<NotificationBanner> {
    return this.apiV2.get(`notifications`);
  }

  public async createNotificationBanner(bannerDetails: NotificationBanner): Promise<NotificationBanner> {
    return this.apiV2.post(`admin/notifications`, bannerDetails);
  }
  public async updateNotificationBanner(bannerDetails: NotificationBanner): Promise<NotificationBanner> {
    return this.apiV2.put(`admin/notifications/${bannerDetails.id}`, bannerDetails);
  }
}

export default new NotificationBannerService();
